import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer justify-center">
      <div className="footer-container  justify-center">
        {/* Quick Links and Company Info */}
        <div className="footer-section">
          <h2 className="footer-title">B.B Info Tech</h2>
          <p className="footer-text">
            Your trusted source for quality tech products. Fast delivery, secure
            payments, and excellent customer service.
          </p>
        </div>

        <div className="footer-section">
          <h2 className="footer-title">Quick Links</h2>
          <ul className="footer-links">
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h2 className="footer-title">Stay Connected</h2>
          <p className="footer-text">Follow us on social media:</p>
          <div className="footer-socials">
            <a href="#">Facebook</a>
            <a href="#">Instagram</a>
            <a href="#">Twitter</a>
          </div>
        </div>
        {/* Map Section */}
        <div className="footer-section map-section">
          <iframe
            title="Kathmandu Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.1233819248846!2d85.32396087527086!3d27.71075542529464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb190d6fbe2297%3A0x90e0f2c4b1f9d68!2sKathmandu%2C%20Nepal!5e0!3m2!1sen!2snp!4v1713705070661!5m2!1sen!2snp"
            width="100%"
            height="250"
            style={{ border: 0, borderRadius: "8px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} B.B Info Tech. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
